import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

import { GraphqlService } from 'src/app/graphql/graphql.service';
import { Contract } from 'src/app/shared/models';
import { AbstractPageForm } from 'src/app/shared/pages/page-form.abstract';

@Component({
	selector: 'pk-broker-generate-poa-modal',
	templateUrl: './generate-poa-modal.component.html',
	styleUrls: ['./generate-poa-modal.component.scss'],
	standalone: false,
})
export class GeneratePoaModalComponent extends AbstractPageForm {
	// inputs
	public contract: Contract;
	public poaAttachmentName: string;

	// outputs
	public submitted: Subject<boolean> = new Subject();

	public latestPoaSentDate: Date;

	constructor(
		private activeModal: BsModalRef,
		private graphqlService: GraphqlService,
		private toastrService: ToastrService,
		private fb: FormBuilder,
	) {
		super();
		this.setSubmitText('Generate', 'Generating...');
	}

	public async loadPageData(): Promise<void> {
		this.latestPoaSentDate = this.contract.latestPoaSentDate();
	}

	public getForm() {
		return this.fb.group({});
	}

	protected async onFormSubmitted() {
		try {
			await this.graphqlService.generatePoa({
				contractId: this.contract.contractId,
			});
		} catch (e) {
			this.toastrService.warning(`${this.poaAttachmentName} template was not found. Please contact support.`, 'Contract');
			return;
		}

		this.submitted.next(true);
		this.close();
	}

	public close(): void {
		this.activeModal.hide();
	}
}
